import { getConfig } from '../config/global';
import { store } from '../store/store';
import { InitState } from '../store/init/state';

export function trackGoogleAnalytics(params: {[key: string]: string}) {
    try {
        const { ga, name } = getConfig();

        const initState = store.getState().initReducer as InitState;

        const customerId = initState.userId;
        const landingId = initState.landingId;

        const querystring = new URLSearchParams({
            ...params,
            ds: name,
            an: 'website-client',
            tid: ga,
            t: 'event',
            v: '1',
            cid: customerId,
            cd1: customerId,
            uid: landingId,
            z: Date.now().toString(),
        });

        fetch(`https://www.google-analytics.com/collect?${querystring.toString()}`, {
            method: 'GET',
        });
    } catch {
        return;
    }
}